import { theme } from '@carvana/purchase-styles';

export interface ScreenSize {
  width: number;
  height: number;
  isWidthXs: boolean;
  isWidthSm: boolean;
  isWidthMd: boolean;
  isWidthLg: boolean;
  isWidthXl: boolean;
  isPortrait: boolean;
  isLandscape: boolean;
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
}

const getSizes = ( height: number, width: number ) => {
  const isWidthXs = width < theme.breakpoints.sm;
  const isWidthSm = width >= theme.breakpoints.sm && width < theme.breakpoints.md;
  const isWidthMd = width >= theme.breakpoints.md && width < theme.breakpoints.lg;
  const isWidthLg = width >= theme.breakpoints.lg && width < theme.breakpoints.xl;
  const isWidthXl = width >= theme.breakpoints.xl;
  const isPortrait = window.screen.height > window.screen.width;
  const isLandscape = window.screen.height < window.screen.width;

  return {
      width,
      height,
      isWidthXs,
      isWidthSm,
      isWidthMd,
      isWidthLg,
      isWidthXl,
      isPortrait,
      isLandscape,
      isMobile: isWidthXs,
      isTablet: isWidthSm,
      isDesktop: isWidthMd || isWidthLg || isWidthXl
    };
}

export default getSizes;
